import axios from 'axios';

const base = () => window.store.event_backend_api;

// media-items stores bytes and nothing else, so a file belongs to nobody until
// its access row lands.
export const uploadResourcesFor = async ({ files, access }) => {
  const formData = new FormData();
  formData.append('multiple', true);
  formData.append('type', 'resources');
  files.forEach(file => formData.append('file[]', file));

  const { data } = await axios.post(`${base()}/media-items`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  const mediaIds = data?.data?.media_ids ?? [];

  await Promise.all(mediaIds.map(id =>
    axios.put(`${base()}/resources/${id}/access`, access)
  ));

  return mediaIds;
};
